import { render, staticRenderFns } from "./chatCliente.vue?vue&type=template&id=3ffda1e8&scoped=true&"
import script from "./chatCliente.vue?vue&type=script&lang=js&"
export * from "./chatCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffda1e8",
  null
  
)

export default component.exports